export const ENABLE_HOLIDAY_THEME = false;

export const winterThemeConfig = {
  confetti: {
    enabled: true,
    particleCount: {
      desktop: 60,
      mobile: 30,
    },
    intensity: 'medium' as 'light' | 'medium' | 'heavy',
  },
  sparkles: {
    enabled: true,
    particleCount: {
      desktop: 40,
      mobile: 20,
    },
  },
  frost: {
    enabled: true,
    opacity: 0.12,
  },
  fireworks: {
    enabled: true,
    count: 8,
  },
  performance: {
    respectReducedMotion: true,
    disableOnLowPerformance: true,
  },
};
